<template>
  <div class="user-search-wrap">
    <IconGlyph name="search" :size="19" />
    <v-autocomplete
      v-model="select"
      :items="users"
      :search-input.sync="search"
      :item-text="createSelectLabel"
      :item-value="createSelectLabel"
      :return-object="returnObject"
      :placeholder="text || 'Search a Bohm contact'"
      class="kiosk-autocomplete"
      autocomplete="off"
      color="accent"
      hide-details
      hide-no-data
      clearable
      flat
      solo
    ></v-autocomplete>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import IconGlyph from "@/components/IconGlyph";

export default {
  name: "UserSearch",
  components: { IconGlyph },
  data() {
    return { select: null, search: null };
  },
  props: {
    text: String,
    returnObject: Boolean
  },
  computed: {
    ...mapGetters({ users: "getUsers" })
  },
  methods: {
    ...mapActions({ userSearch: "getUsers" }),
    createSelectLabel(user) {
      return user && user.displayName ? user.displayName : "";
    },
    clear() {
      this.select = null;
      this.search = null;
    }
  },
  watch: {
    select(employee) {
      this.$emit("employee-selected", employee);
    },
    search(value) {
      if (value) this.userSearch(value);
    }
  }
};
</script>

<style>
.user-search-wrap {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding-left: 15px;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #dfe3dd;
  border-radius: 12px;
  background: #fbfbf9;
  color: var(--accent);
  transition: border 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.user-search-wrap:focus-within {
  border-color: var(--accent);
  background: white;
  box-shadow: 0 0 0 4px rgba(77, 86, 84, 0.1);
}

.kiosk-autocomplete {
  flex: 1;
  min-width: 0;
  margin: 0 !important;
  padding: 0 5px !important;
}

.kiosk-autocomplete.v-text-field > .v-input__control > .v-input__slot {
  min-height: 50px !important;
  padding: 0 8px !important;
  background: transparent !important;
  box-shadow: none !important;
}

.kiosk-autocomplete input {
  color: var(--ink) !important;
  font-size: 14px !important;
}

.kiosk-autocomplete input::placeholder {
  color: #aab1ad !important;
  opacity: 1;
}

.kiosk-autocomplete .v-input__append-inner {
  margin-top: 15px !important;
}
</style>
